import type { ReactElement } from 'react';

import { checkModelIsNotOther } from 'Components/Insights/hooks/useGetMakesAndModels.helpers';
import { useInsightsStore } from 'Stores/InsightsStore/InsightsStore';
import { MakeLogo } from 'Storybook/core/MakeLogo/MakeLogo';
import type { UseInsightsRecentSoldResult } from 'Utilities/hooks/recentSoldPrices/useRecentSoldPrices';
import { useCypressData } from 'Utilities/hooks/useCypressData';

import { DataLastUpdated } from '../DataLastUpdated/DataLastUpdated';

import styles from './Title.module.scss';

type TitleProps = {
	insightsRecentSold: UseInsightsRecentSoldResult;
};

export const Title = ({ insightsRecentSold }: TitleProps): ReactElement => {
	const { make, model } = useInsightsStore((state) => state);
	const [cypressIds, applyCypressDataId] = useCypressData();
	const isOtherModel = !checkModelIsNotOther(model.namePretty);

	return (
		<div className={styles.container}>
			<div className={styles.vehicle}>
				<MakeLogo className={styles.logo} data-testid="car-logo" make={make.slug} />
				<h1 {...applyCypressDataId(cypressIds.text.insights.results.heading)} className={styles.title}>
					{make.name} {isOtherModel ? null : model.namePretty}
				</h1>
			</div>
			<DataLastUpdated insightsRecentSold={insightsRecentSold} />
		</div>
	);
};
